import { render, staticRenderFns } from "./kneeHurt.vue?vue&type=template&id=6ace9be0&scoped=true&"
import script from "./kneeHurt.vue?vue&type=script&lang=js&"
export * from "./kneeHurt.vue?vue&type=script&lang=js&"
import style0 from "./kneeHurt.vue?vue&type=style&index=0&id=6ace9be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace9be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ace9be0')) {
      api.createRecord('6ace9be0', component.options)
    } else {
      api.reload('6ace9be0', component.options)
    }
    module.hot.accept("./kneeHurt.vue?vue&type=template&id=6ace9be0&scoped=true&", function () {
      api.rerender('6ace9be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/kneeHurt.vue"
export default component.exports